// ── 상황판 직원 본인 위젯 — 셀 렌더 유틸 (2026-06-09 통합) ─────────────────────
//
// 2026-06-09 사용자 명세:
//   본인 위젯 + 큰 카드 + admin 위젯 — 한 grid / 한 SortableContext / 사이즈 무관 자유 자리변경.
//   PersonalMiniSection 컴포넌트는 더 이상 호출하지 않음 (deprecate).
//   SbContent 가 renderPersonalCell 만 호출해 통합 grid 안에서 본인 위젯을 그림.
//
// accentMap (선택): { [code]: accentKey } — 사용자가 위젯 설정 모달에서 지정한 색상
//   각 위젯의 spec 기본 accent 보다 우선 적용 (MiniRow 가 최종 결정).

import React from 'react';
import { MyAttendanceToggleMini, MyLeaveBalanceMini } from './personalwidgets/AttendanceWidgets';
import { MyDailyCallSummaryMini, MyCallTodayMini, MyContractsMonthMini } from './personalwidgets/TmWidgets';
import { MyMeetingTodayMini, MyRegionRecommendedMini } from './personalwidgets/MeetingWidgets';
import {
  MySettlementOwedPineMini, MySettlementOwedDotMini, MySettlementOwedLnjMini,
} from './personalwidgets/SettlementWidgets';

// 모든 본인 위젯 코드 — useMyPersonalWidgets 와 일치
export const PERSONAL_WIDGET_CODES = [
  'my_attendance_toggle',
  'my_leave_balance',
  'my_daily_call_summary',
  'my_call_today',
  'my_contracts_month',
  'my_meeting_today',
  'my_region_recommended',
  'my_settlement_owed_pine',
  'my_settlement_owed_dot',
  'my_settlement_owed_lnj',
];

export function countVisiblePersonalWidgets(visibleSet) {
  return PERSONAL_WIDGET_CODES.filter((c) => visibleSet.has(c)).length;
}

// 위젯 코드 → JSX 셀 매핑 함수 (sortableId = code)
// ov(code) → accentOverride(code) 헬퍼 (SbContent 에서 주입)
// navOnClickFor(code) → 짧은 클릭 시 navigate 함수 (없으면 undefined) — 2026-06-16 사용자 명세
export function renderPersonalCell(code, personal, ov, navOnClickFor) {
  if (!personal) return null;
  const nav = (c) => (typeof navOnClickFor === 'function' ? navOnClickFor(c) : undefined);
  switch (code) {
    case 'my_attendance_toggle':
      return (
        <MyAttendanceToggleMini
          key="my_attendance_toggle"
          attendance={personal.attendance}
          actionLoading={personal.actionLoading}
          onCheckIn={personal.handleCheckIn}
          onCheckOut={personal.handleCheckOut}
          accentOverride={ov('my_attendance_toggle')}
          sortableId="my_attendance_toggle"
          onClick={nav('my_attendance_toggle')}
        />
      );
    case 'my_leave_balance':
      return <MyLeaveBalanceMini key="my_leave_balance" data={personal.leaveBalance} accentOverride={ov('my_leave_balance')} sortableId="my_leave_balance" onClick={nav('my_leave_balance')} />;
    case 'my_daily_call_summary':
      return <MyDailyCallSummaryMini key="my_daily_call_summary" data={personal.dailyCallSummary} accentOverride={ov('my_daily_call_summary')} sortableId="my_daily_call_summary" onClick={nav('my_daily_call_summary')} />;
    case 'my_call_today':
      return <MyCallTodayMini key="my_call_today" data={personal.callToday} accentOverride={ov('my_call_today')} sortableId="my_call_today" onClick={nav('my_call_today')} />;
    case 'my_contracts_month': {
      const ym = personal.monthMap?.my_contracts_month
        || personal.contractsMonth?.monthYm
        || '';
      return (
        <MyContractsMonthMini
          key="my_contracts_month"
          data={personal.contractsMonth}
          month={ym}
          onMonthChange={personal.setMonthForCode
            ? (m) => personal.setMonthForCode('my_contracts_month', m)
            : undefined}
          accentOverride={ov('my_contracts_month')}
          sortableId="my_contracts_month"
          onClick={nav('my_contracts_month')}
        />
      );
    }
    case 'my_meeting_today':
      return <MyMeetingTodayMini key="my_meeting_today" data={personal.meeting} accentOverride={ov('my_meeting_today')} sortableId="my_meeting_today" onClick={nav('my_meeting_today')} />;
    case 'my_region_recommended':
      return <MyRegionRecommendedMini key="my_region_recommended" data={personal.regionRecommended} accentOverride={ov('my_region_recommended')} sortableId="my_region_recommended" onClick={nav('my_region_recommended')} />;
    case 'my_settlement_owed_pine':
      return <MySettlementOwedPineMini key="my_settlement_owed_pine" data={personal.settlementOwedPine} accentOverride={ov('my_settlement_owed_pine')} sortableId="my_settlement_owed_pine" onClick={nav('my_settlement_owed_pine')} />;
    case 'my_settlement_owed_dot':
      return <MySettlementOwedDotMini key="my_settlement_owed_dot" data={personal.settlementOwedDot} accentOverride={ov('my_settlement_owed_dot')} sortableId="my_settlement_owed_dot" onClick={nav('my_settlement_owed_dot')} />;
    case 'my_settlement_owed_lnj':
      return <MySettlementOwedLnjMini key="my_settlement_owed_lnj" data={personal.settlementOwedLnj} accentOverride={ov('my_settlement_owed_lnj')} sortableId="my_settlement_owed_lnj" onClick={nav('my_settlement_owed_lnj')} />;
    default:
      return null;
  }
}
